module.exports = __webpack_public_path__ + "img/crm.df2dfba6.svg";